var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoTwinBed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.093,
    height: 19.951,
    viewBox: "0 0 17.093 19.951",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "noun-hat-1529054",
    d: "M174,117.375v4.935h17.093v-4.935h-1.974l-4.5-9.149h0a3.3,3.3,0,1,0-4.045.072l-4.6,9.076Zm15.649,3.491h-14.2v-2.046h14.2Zm-7.1-17.045a1.854,1.854,0,1,1-1.311.543A1.854,1.854,0,0,1,182.547,103.82Zm-.65,5.08.65.048h0a2.694,2.694,0,0,0,.77-.1l4.213,8.523h-9.919Z",
    transform: "translate(-174 -102.359)",
    fill: "#1d1d1f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoTwinBed);
export default __webpack_public_path__ + "static/media/icoTwinBed.ade5fc08e179f5f0f1cca40c5851b676.svg";
export { ForwardRef as ReactComponent };